export default "__VITE_ASSET__DRPY5zW1__"